import React from 'react';
import { Descriptions, Modal, Image, Row, Col, Tag } from 'antd';
import { useCurrentRegisterTaxiDriver } from '../hooks/useCurrentRegisterTaxiDriver';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { convertDateToFormat } from '../../../shared/Utils';

const RegisterTaxiDriverViewModal = ({ isOpen, onRequestClose }) => {
    const { currentRegisterTaxiDriver } = useCurrentRegisterTaxiDriver();

    const handleCancel = () => {
        onRequestClose(false);
    };

    const imageDocuments = [
        { label: 'National ID (Front)', index: 0 },
        { label: 'National ID (Back)', index: 1 },
        { label: "Driver's Licence", index: 2 },
        { label: 'Gray Card (Front)', index: 3 },
        { label: 'Gray Card (Back)', index: 4 },
        { label: 'Professional Card', index: 5 },
        { label: 'Car Insurance', index: 6 },
        { label: 'Additional Attachments', index: 7 },
    ];

    const getStatusColor = (status) => {
        switch (status) {
            case 'Pending':
                return '#ff0d0dff';
            case 'In progress':
                return '#FFA500';
            case 'Confirmed':
                return '#50C878';
            default:
                return 'default';
        }
    };

    return (
        <Modal width={800} open={isOpen} onCancel={handleCancel} footer={null}>
            <Descriptions title={`Taxi Driver details #${currentRegisterTaxiDriver?._id}`} bordered column={1}>
                <Descriptions.Item label="Driver">
                    <Row gutter={24} wrap={false}>
                        <Col>
                            <Image width={150} src={currentRegisterTaxiDriver?.driverPhoto?.url} />
                        </Col>

                        <Col flex="auto">
                            <Descriptions column={1} size="small">
                                <Descriptions.Item label="Full Name">
                                    {currentRegisterTaxiDriver?.fullName}
                                </Descriptions.Item>

                                <Descriptions.Item label="Birthday">
                                    {currentRegisterTaxiDriver?.birthday
                                        ? convertDateToFormat(currentRegisterTaxiDriver?.birthday, 'DD-MM-YYYY')
                                        : '-'}
                                </Descriptions.Item>

                                <Descriptions.Item label="Email">{currentRegisterTaxiDriver?.email}</Descriptions.Item>

                                <Descriptions.Item label="Phone">
                                    {currentRegisterTaxiDriver?.phoneNumber}
                                </Descriptions.Item>
                                <Descriptions.Item label="ID Card">
                                    {currentRegisterTaxiDriver?.idCard}
                                </Descriptions.Item>
                                <Descriptions.Item label="Register Status">
                                    <Tag color={getStatusColor(currentRegisterTaxiDriver?.registerStatus)}>
                                        {currentRegisterTaxiDriver?.registerStatus}
                                    </Tag>
                                </Descriptions.Item>
                                <Descriptions.Item label="Account Status">
                                    {currentRegisterTaxiDriver?.accountStatus === 'Active' ? (
                                        <span style={{ fontWeight: 'bold', color: '#389e0d' }}>
                                            <CheckCircleOutlined /> Active
                                        </span>
                                    ) : (
                                        <span style={{ color: '#8c8c8c' }}>
                                            <CloseCircleOutlined /> Inactive
                                        </span>
                                    )}
                                </Descriptions.Item>
                            </Descriptions>
                        </Col>
                    </Row>
                </Descriptions.Item>
                <Descriptions.Item label="LicenseNumber">{currentRegisterTaxiDriver?.licenseNumber}</Descriptions.Item>
                <Descriptions.Item label="Immatriculation">
                    <span style={{ direction: 'ltr', unicodeBidi: 'plaintext' }}>
                        {currentRegisterTaxiDriver?.immatriculation}
                    </span>
                </Descriptions.Item>
                <Descriptions.Item label="Color">
                    <Tag
                        key={currentRegisterTaxiDriver?.color}
                        color={currentRegisterTaxiDriver?.color}
                        style={{ textTransform: 'capitalize' }}
                    >
                        {currentRegisterTaxiDriver?.color}
                    </Tag>
                </Descriptions.Item>

                <Descriptions.Item label="Documents">
                    <Row gutter={[16, 16]}>
                        {imageDocuments.map(({ label, index }) => (
                            <Col key={index} xs={24} sm={12} md={6} lg={6} xl={6}>
                                <div style={{ textAlign: 'center' }}>
                                    {currentRegisterTaxiDriver?.documentsPhotos?.[index]?.url ? (
                                        <Image
                                            width="100%"
                                            src={currentRegisterTaxiDriver?.documentsPhotos?.[index]?.url}
                                            alt={label}
                                            style={{ borderRadius: 8 }}
                                        />
                                    ) : (
                                        <div
                                            style={{
                                                width: '100%',
                                                height: 100,
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                backgroundColor: '#f0f0f0',
                                                borderRadius: 8,
                                            }}
                                        >
                                            <span style={{ color: '#999' }}>No {label}</span>
                                        </div>
                                    )}
                                    <div style={{ marginTop: 8, fontSize: 14 }}>{label}</div>
                                </div>
                            </Col>
                        ))}
                    </Row>
                </Descriptions.Item>
            </Descriptions>
        </Modal>
    );
};

export default RegisterTaxiDriverViewModal;
